import { AssignMultipleDevicesRequest } from "@/gen/api"
import { councilDeviceApi } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export type UseAssignDevicesToCustomerParams = {
  onSuccess?: () => void
  onError?: (e: Error) => void
}

const useAssignDevicesToCustomer = (params: UseAssignDevicesToCustomerParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...(params.onError ? { onError: params.onError } : {}),
    mutationFn: async (data: {
      councilId: string
      assignMultipleDevicesRequest: AssignMultipleDevicesRequest
    }) => {
      try {
        const response = await councilDeviceApi.assignDeviceToUser(
          data.councilId,
          data.assignMultipleDevicesRequest,
        )
        return response.data
      } catch (error: unknown) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error as { response?: { data?: { message?: string } } }
          if (err.response?.data?.message) {
            throw new Error(err.response.data.message)
          }
        }
        throw error
      }
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["devices", variables.councilId] })
      queryClient.invalidateQueries({ queryKey: ["platform-devices", variables.councilId] })
      params.onSuccess?.()
    },
  })
}

export default useAssignDevicesToCustomer
